
import React from "react";
import { Dropdown, Nav } from "react-bootstrap";
import config from "../config/app.config";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ApiOutlined,
  LaptopOutlined,
  GlobalOutlined,
  LoadingOutlined,
  PoweroffOutlined,
} from "@ant-design/icons";
import { Divider, Button, Select } from "antd";
import MainMenu from "./Menu/menu";
import {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
} from "../actions";
import UserImage from "../assets/images/icon/profile.png";
import { withTranslation } from "react-i18next";
import Apiauth from "../api/Apiauth";
import AppContext from "./AppContext";
import Logo from "../assets/images/logo/payeasy1.1.png";
import { CheckTypeAdmin } from "../helpers/checkPermission";
import {
  NetworkConnection,
  getActiveMerchantData,
  getOS,
  handleLogout,
  isMobile,
  showToast,
  updateNetworkStatus,
} from "../utils";
import { tagsColorBalance } from "../helpers/tagsBage";
import SelectLanguage from "./Dropdown/SelectLanguage";
import { DropdownContentWallet } from "./Dropdown/DropdownContentWallet";

class NavbarMenu extends React.Component {
  static contextType = AppContext;
  menuRef = React.createRef();

  constructor(props) {
    super(props);
    const active_merchantId = parseInt(localStorage.getItem("selectedID"), 10) || 0;
    this.state = {
      currentLang: props.i18n.language,
      spinning: false,
      isMenuOpen: false,
      active_merchantId,
    };
  }

  componentDidMount() {
    this.props.tostMessageLoad?.(true);
    updateNetworkStatus();

    if (this.props.activeKey) {
      this.activeMenutabwhenNavigate("/" + this.props.activeKey);
    }

    // จัดการ Event Listener i18n
    if (this.props.i18n?.on) {
      this.props.i18n.on("languageChanged", this.handleLanguageChange);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isMobile: isMobileDevice } = this.context;
    const { isMenuOpen, active_merchantId } = this.state;

    // 1. ตรวจสอบและซิงค์ Merchant ID จาก localStorage ป้องกัน Infinite Loop
    const activeFromStorage = parseInt(localStorage.getItem("selectedID"), 10) || null;
    if (activeFromStorage !== active_merchantId) {
      this.setState({ active_merchantId: activeFromStorage });
    }

    // 2. จัดการ Event Listener และ UI Overlay เมื่อสถานะ เมนู เปิด/ปิด เปลี่ยนแปลง
    if (isMenuOpen !== prevState.isMenuOpen) {
      if (isMenuOpen) {
        document.addEventListener("mousedown", this.handleClickOutside);
        document.body.classList.add("offcanvas-active");
        this.handleBodyScroll(isMobileDevice);
      } else {
        document.removeEventListener("mousedown", this.handleClickOutside);
        document.body.classList.remove("offcanvas-active");
        this.handleBodyScroll(false);
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.body.classList.remove("offcanvas-active");
    this.handleBodyScroll(false);

    if (this.props.i18n?.off) {
      this.props.i18n.off("languageChanged", this.handleLanguageChange);
    }
  }

  handleLanguageChange = (lng) => {
    this.setState({ currentLang: lng }, () => {
      updateNetworkStatus();
    });
  };

  handleBodyScroll = (shouldDisableScroll) => {
    const body = document.body;
    const overlay = document.getElementById("overlay");
    if (shouldDisableScroll) {
      body.classList.add("no-scroll");
      if (overlay) overlay.className = "overlay active";
    } else {
      body.classList.remove("no-scroll");
      if (overlay) overlay.className = "overlay";
    }
  };

  toggleCollapsed = () => {
    const sidebar = document.getElementById("left-sidebar");
    if (sidebar) sidebar.classList.toggle("collapsed");

    this.setState((prevState) => {
      const newState = !prevState.isMenuOpen;
      if (this.context.isMobile) {
        this.handleBodyScroll(newState);
      }
      if (window.innerWidth >= 1025 && sidebar) {
        sidebar.style.width = "256px";
      }
      return { isMenuOpen: newState };
    });
  };

  handleClickOutside = (event) => {
    const width = window.innerWidth;
    const sidebar = document.getElementById("left-sidebar");

    if (
      width < 1025 &&
      sidebar &&
      !sidebar.contains(event.target) &&
      this.state.isMenuOpen
    ) {
      this.setState({ isMenuOpen: false }, () => {
        sidebar.classList.add("collapsed");
        this.handleBodyScroll(false);
      });
    }
  };

  handleClickToProfile = (page) => {
    const { history } = this.props;
    if (history) history.push(page);
    if (window.innerWidth < 1025) {
      this.toggleCollapsed();
    }
  };

  activeMenutabwhenNavigate(activeKey) {
    const keyMap = {
      "/dashboard": "dashboradContainer",
      "/bank-bank-customer": "AppContainer",
      "/login": "WidgetsContainer",
      "/invoices": "PagesContainer",
    };
    if (keyMap[activeKey]) {
      this.activeMenutabContainer(keyMap[activeKey]);
    }
  }

  activeMenutabContainer(id) {
    const parents = document.getElementById("main-menu");
    const activeMenu = document.getElementById(id || "dashboradContainer");

    if (parents) {
      Array.from(parents.children).forEach((child) => {
        if (child.id !== id) {
          child.classList.remove("active");
          child.children[1]?.classList.remove("in");
        }
      });
    }
    activeMenu?.classList.toggle("active");
    activeMenu?.children[1]?.classList.toggle("in");
  }

  handleChange = (value) => {
    if (!value) {
      alert("Your is not selected merchant id");
      return;
    }

    this.setState({ spinning: true });
    Apiauth.getSelectMerchant({ Active_merchantId: value })
      .then((res) => {
        if (res.data?.success) {
          showToast("success", res.data.message);
          localStorage.setItem("selectedID", value);
          setTimeout(() => {
            window.location.assign("/dashboard");
            this.setState({ spinning: false });
          }, 1500);
        } else {
          showToast("error", res.data?.message || "Failed to change merchant");
          this.setState({ spinning: false });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ spinning: false });
      });
  };

  render() {
    const { t, i18n, location, themeColor, sideMenuTab } = this.props;
    const { spinning, isMenuOpen } = this.state;
    const context = this.context;

    if (themeColor) document.body.classList.add(themeColor);

    const {
      resAllDataMerchang,
      loadingBankAccounts,
      balance,
      resProfileAdmin,
      reloading,
      loadingMenu,
      isMerchantData,
      merchantId,
      accPayoutActiveBank,
      activeAccountData,
    } = context;

    const userInfo = resProfileAdmin || {};
    const ArrayData = Array.isArray(activeAccountData) ? activeAccountData : [];
    const ArrayDatacPayoutActiveBank = Array.isArray(accPayoutActiveBank) ? accPayoutActiveBank : [];

    const accPayinActiveBank = ArrayData.filter((o) => o?.accountType === "deposit" && o?.status_bank === "Active");
    const statusWit = ArrayDatacPayoutActiveBank.length;
    const statusDep = accPayinActiveBank.length;

    const merchantData = getActiveMerchantData(resAllDataMerchang);
    const merchantCredit = merchantData?.balance;
    const stg = process.env.REACT_APP_ENV === "staging";
    const arrData = Array.isArray(resAllDataMerchang) ? resAllDataMerchang : [];

    const { name, id } = isMerchantData || {};
    const loading = spinning || reloading || loadingMenu;
    const u = userInfo?.username || "";
    const displayU = u.length > 10 ? `${u.substring(0, 10)}...` : u;
    const role = ["Owner", `Owner${id}`, `Owner${id} (เจ้าของ)`].includes(userInfo?.role)
      ? "Owner"
      : userInfo?.role;

    return (
      <div className={`is_${merchantCredit}`}>
        {/* Loading Overlay */}
        <div
          className="page-loader-wrapper"
          style={{ display: spinning ? "block" : "none" }}
        >
          <div className="loader">
            <div className="m-t-30">
              <LoadingOutlined style={{ fontSize: "48px", color: "#fff" }} />
            </div>
            <p>Loading...</p>
          </div>
        </div>

        {/* Top Navbar */}
        <nav className="navbar navbar-fixed-top">
          <div className="container-fluid">
            <div className="navbar-btn lg-hiden">
              <Button
                id="btn-toggle-offcanvas"
                style={{ padding: 10, fontSize: "14px" }}
                type="default"
                className="btn-toggle-offcanvas"
                onClick={this.toggleCollapsed}
              >
                {isMenuOpen ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              </Button>
            </div>

            <div className="navbar-brand">
              <img src={Logo} alt="Logo" className="img-responsive logo" />
            </div>

            <div className="navbar-right">
              <form id="navbar-search" className="navbar-form search-form">
                <input
                  className="form-control"
                  placeholder="Search here..."
                  type="text"
                />
                <button type="button" className="btn btn-default">
                  <i className="icon-magnifier"></i>
                </button>
              </form>

              <div id="navbar-menu">
                <ul className="nav navbar-nav">
                  <li>
                    <span
                      className="icon-menu dropbtn-wallet fs-sm-18 fs-15"
                      style={{ fontSize: "15px", color: "#3eacff" }}
                    >
                      <span
                        id="BalanceIn-top-nav"
                        className="wallet-main"
                        style={{
                          fontWeight: "600",
                          marginRight: 3,
                          color: tagsColorBalance(balance),
                          fontSize: 13,
                        }}
                      >
                        {loadingBankAccounts ? (
                          <LoadingOutlined />
                        ) : (
                          <>
                            <span style={{ fontSize: 12 }}>THB </span>
                            {Intl.NumberFormat().format(parseFloat(balance || 0).toFixed(2))}
                          </>
                        )}
                      </span>
                      <DropdownContentWallet
                        accPayoutActiveBank={accPayoutActiveBank}
                        loadingBankAccounts={loadingBankAccounts}
                        name={name}
                        t={t}
                      />
                    </span>
                  </li>

                  <li className="icon-menu mt-1">
                    <SelectLanguage t={t} i18n={i18n} />
                  </li>

                  <li
                    className="icon-menu hover"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleLogout()}
                  >
                    <Button
                      size="small"
                      id="showBTN"
                      color="red"
                      variant="solid"
                      shape="circle"
                      icon={<PoweroffOutlined style={{ fontSize: 13 }} />}
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>

        {/* Sidebar */}
        <div
          id="left-sidebar"
          className="sidebar"
          style={{ zIndex: 11, width: 256, display: "block" }}
        >
          <div className="sidebar-scroll">
            <div className="user-account mt-sm-20 mt-md-40">
              <img
                onClick={() => this.handleClickToProfile("/profile")}
                id="networkStatus"
                src={UserImage}
                className="rounded-circle user-photo"
                alt="User Profile"
              />
              <Dropdown>
                <span>{t("welcome")},</span>
                <Dropdown.Toggle
                  variant="none"
                  as="a"
                  onClick={() => this.handleClickToProfile("/profile")}
                  id="dropdown-basic"
                  className="user-name text-truncate"
                >
                  <strong
                    className="hover"
                    title={t("Profile")}
                    style={{ color: "rgb(90 90 90)", fontWeight: "700", cursor: "pointer" }}
                  >
                    <div className="text-truncate fs-12 d-inline" style={{ width: 150 }}>
                      {displayU}{" "}
                      <small style={{ fontSize: 8 }}>
                        (
                        {["programer", "superadmin", "agent"].includes(userInfo?.admin_type)
                          ? userInfo?.admin_type
                          : role}
                        )
                      </small>
                    </div>
                  </strong>
                </Dropdown.Toggle>

                <small className="d-block mt-2" style={{ color: "#888" }}>
                  {isMobile() ? (
                    <i className="bx bx-mobile" style={{ fontSize: 14 }}></i>
                  ) : (
                    <LaptopOutlined style={{ fontSize: 14 }} />
                  )}{" "}
                  : <span>{getOS()?.os}</span>
                </small>

                <small className="d-block" style={{ color: "#888" }}>
                  <GlobalOutlined style={{ fontSize: 14 }} /> :{" "}
                  <span
                    style={{
                      color: NetworkConnection() ? "#52c41a" : "#c72020",
                      fontSize: 12,
                    }}
                  >
                    <i
                      className={`bx bxs-circle ${NetworkConnection() ? "bx-flashing" : ""}`}
                      style={{
                        color: NetworkConnection() ? "#52c41a" : "#c72020",
                        fontSize: 8,
                      }}
                    ></i>{" "}
                    {NetworkConnection() ? t("online") : t("offline")}
                  </span>
                </small>
              </Dropdown>
              <hr />

              {/* Merchant & Account Status */}
              <ul className="row list-unstyled" style={{ marginRight: "10px", alignItems: "center" }}>
                <li className="col-6 p-1 fs-sm-12">
                  <b>{t("Merchant")}</b><br />
                  <b>{t("deposit")}</b><br />
                  <b>{t("withdrawal")}</b>
                </li>
                <li className="col-6 p-1">
                  <span
                    title={name}
                    id="BalanceIn"
                    className="text-truncate"
                    style={{
                      fontWeight: "600",
                      color: "#00000087",
                      maxWidth: "100px",
                      fontSize: name?.length > 10 ? 12 : 14,
                    }}
                  >
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {arrData.find((o) => o.id === id)?.name || t("No data")}{" "}
                        {stg ? "(STG)" : merchantId ? `(${merchantId})` : null}
                      </>
                    )}
                  </span>
                  <br />

                  <span className="text-truncate">
                    {statusDep === 0 ? (
                      <span style={{ color: "red", fontSize: "12px" }}>{t("Inactive")}</span>
                    ) : (
                      <span style={{ fontSize: "12px", color: "rgb(82, 196, 26)" }}>
                        {t("active")} {statusDep} {t("Account")}
                      </span>
                    )}
                  </span>
                  <br />

                  <span className="text-truncate">
                    {statusWit === 0 ? (
                      <span style={{ color: "red", fontSize: "12px" }}>{t("Inactive")}</span>
                    ) : (
                      <span style={{ fontSize: "12px", color: "rgb(82, 196, 26)" }}>
                        {t("active")} {statusWit} {t("Account")}
                      </span>
                    )}
                  </span>
                </li>
              </ul>
            </div>

            {/* Navigation Tabs */}
            <ul className="nav nav-tabs">
              <li className="nav-item" style={{ marginRight: "5px" }}>
                <Link
                  to="#menu"
                  title="Menu"
                  className={sideMenuTab?.[0] ? "nav-link active" : "nav-link"}
                  data-toggle="tab"
                  onClick={() => this.props.onPressSideMenuTab(0)}
                >
                  <i className="fa fa-th-list" />
                </Link>
              </li>
              <li className="nav-item">
                <Select
                  loading={loading}
                  value={loading ? "loading..." : id || undefined}
                  disabled={!CheckTypeAdmin(userInfo)}
                  style={{ width: 203 }}
                  onChange={this.handleChange}
                  placeholder={loading ? "loading..." : t("Select Option")}
                  prefix={
                    loading ? (
                      <LoadingOutlined />
                    ) : (
                      <i
                        className="bx bxs-circle bx-flashing"
                        style={{ color: "#52c41a", fontSize: "10px" }}
                      />
                    )
                  }
                  suffixIcon={<ApiOutlined style={{ fontSize: "15px", color: "rgb(84 84 84)" }} />}
                  options={
                    !loading && Array.isArray(arrData)
                      ? arrData.map((item, index) => ({
                        value: item.id,
                        filter: item.name,
                        disabled: item.id === id,
                        label: (
                          <span style={{ fontWeight: item.id === id ? "600" : "400" }}>
                            {index + 1}. {item.name} ({item.id})
                          </span>
                        ),
                      }))
                      : []
                  }
                />
              </li>
            </ul>

            {/* Menu Container */}
            <div className="tab-content p-l-0 p-r-0">
              <div className={sideMenuTab?.[0] ? "tab-pane active show" : "tab-pane"} id="menu">
                <Nav id="left-sidebar-nav" className="sidebar-nav">
                  <MainMenu
                    collapsed={isMenuOpen}
                    toggleCollapsed={this.toggleCollapsed}
                    onLocleChang={context.onLocleChang}
                    countCustomer={context.countCustomer}
                    activeKey1={context.activeKey1}
                    handleReload={context.handleReload}
                    countTransApprove={context.countTransApprove}
                    countVerifySlip={context.countVerifySlip}
                    countTransDeposit={context.countTransDeposit}
                    countTransWithdraw={context.countTransWithdraw}
                    roleObject={context.roleObject}
                    menuObject={context.menuObject}
                    menuPaths={context.menuPaths}
                    levelKeys={context.levelKeys}
                    isPermissionAdmin={context.isPermissionAdmin}
                    loadingMenu={loadingMenu}
                    fetchPromiseData={context.fetchPromiseData}
                    setLoadingMenu={context.setLoadingMenu}
                    resProfileAdmin={resProfileAdmin}
                    location={location}
                    countVerifyCustomer={context.countVerifyCustomer}
                  />
                </Nav>
                <Divider>
                  <small style={{opacity: 0.5}}>
                    Version: {config.version}
                    {/* <Link style={{ color: "#888" }} to="/updateList">
                      Version: {config.version}
                    </Link> */}
                  </small>
                </Divider>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NavbarMenu.propTypes = {
  themeColor: PropTypes.string.isRequired,
  sideMenuTab: PropTypes.array.isRequired,
  tostMessageLoad: PropTypes.func.isRequired,
  onPressSideMenuTab: PropTypes.func.isRequired,
};

const mapStateToProps = ({ navigationReducer }) => ({
  themeColor: navigationReducer.themeColor,
  sideMenuTab: navigationReducer.sideMenuTab,
});

export default connect(mapStateToProps, {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
})(withTranslation()(NavbarMenu));